import React, { useEffect, useState } from "react";
import moment from "moment";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import NoImage from "../../assets/images/noImage.jpg";
import leftarrow from "../../assets/images/leftarrow.png";
import rightarrow from "../../assets/images/rightarrow.png";
import { useStores } from "../../stores";
import notify from "../Notify/notify";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";
import VisibilitySensor from "react-visibility-sensor";

const CentersListView = ({
  item,
  navigate,
  date,
  accessKey,
  changeDate,
  cityid,
  pickedDate,
  searchParamsVal,
  refs,
  centerList,
  index,
  screen
}) => {

  const { bookingStore } = useStores();
  const [inventoryId, setInventoryId] = useState(item?.inventories[0]?.id);
  const [selectedItem, setSelectedItem] = useState(item?.inventories[0]);
  const [centerId, setCenterId] = useState(0);
  const [centerLists, setCenterLists] = useState(centerList);
  const [selectedMeetingSlots, setSelectedMeetingSlots] = useState("");

  const [selectedInventory, setSelectedInventory] = useState();
  const [selectedInventoryImage, setSelectedInventoryImage] = useState("");
  const [selectedDate, setSelectedDate] = useState(date);
  const [selectedSlotArr, setSelectedSlotArr] = useState(
    new Array(selectedMeetingSlots?.length).fill(false)
  );
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [selecteArrayOfIndex, setSelectedArrayOfIndex] = useState([]);
  const [disableSlots, setDisableSlots] = useState([]);
  const [isSelected, setIsSelected] = useState(false);
  const [timeSlotActive, setTimeSlotActive] = useState(false);
  const [cardShowVisible, setCardVisible] = useState(false)


  useEffect(() => {
    if (timeSlotActive === true) {
      let temp = new Date().getHours();
      let arr = [];
      let index = "";
      selectedMeetingSlots?.map((item, index) => {
        if (Number(item?.start?.split(":")[0]) >= temp) {
          arr.push({
            item,
            index,
          });
        }
      });
      index = Number(arr[0]?.index);
      setCarouselIndex(index);
    }
  }, [timeSlotActive]);

  useEffect(() => {
    let tempArr = [];
    let temp = new Date().getHours();
    if (selectedMeetingSlots?.length > 0) {
      selectedMeetingSlots?.map((item) => {
        item.isSelected = false;
        if (Number(item?.start?.split(":")[0]) < temp) {
          tempArr.push({
            item,
          });
        }
        setDisableSlots(tempArr);
      });
      // new Array(selectedMeetingSlots.length).fill(false)
    }
  }, []);

  // useEffect(() => {
  //   getMeetingSlot(item?.inventories[0]?.id);
  // }, [item?.inventories]);

  const getSelectedMeetingSlots = (slot, index2) => {
    // console.log("slected index ", index2);
    let selectedmeetingarray = [];
    selectedMeetingSlots.map((item) => {
      if (item.index === slot.index) {
        let obj = item;
        if (obj.isSelected) {
          obj.isSelected = false;
          for (let i = 0; i < selectedMeetingSlots.length; i++) {
            if (selectedMeetingSlots[i].index > slot.index) {
              selectedMeetingSlots[i].isSelected = false;
            }
          }
        } else {
          obj.isSelected = true;
        }
        selectedmeetingarray.push(obj);
      } else {
        selectedmeetingarray.push(item);
      }
    });

    let arrayOfIndex = [];
    selectedmeetingarray?.map((item) => {
      if (item.isSelected) {
        arrayOfIndex.push(item.index);
      }
    });

    setSelectedArrayOfIndex(arrayOfIndex);
    let check = areConsecutiveSlot(arrayOfIndex);
    if (check) {
      setSelectedMeetingSlots(selectedmeetingarray);
    } else {
      selectedmeetingarray.map((item) => {
        // if (item.index === arrayOfIndex[arrayOfIndex.length - 1]) {
        if (item.index === slot.index) {
          let obj = item;
          obj.isSelected = false;
        }
      });

      setSelectedMeetingSlots(selectedmeetingarray);
    }
  };

  const getMeetingSlot = async (id) => {
    let params = `inventory_id=${id}&date=${selectedDate}`;
    await bookingStore.getMeetingSlot(params, (response) => {
      if (response?.data?.status === 1) {
        let responseData = response?.data?.data[0];
        let responseData2 = response?.data?.data;
        let selected = responseData2.filter((x) => x.id === id);
        // console.log("selected", selected);
        setSelectedMeetingSlots(selected[0].meeting_slots);
        setSelectedInventory(responseData);
        setSelectedInventoryImage(responseData?.images);
        setSelectedItem(responseData);
        // console.log("responseData",responseData);
      } else {
        console.log("error");
      }
    });
  };

  const areConsecutiveSlot = (selectedSlotArr) => {
    const sortedArr = selectedSlotArr.sort((a, b) => a - b);
    for (let i = 1; i < sortedArr.length; i++) {
      if (sortedArr[i] !== sortedArr[i - 1] + 1) {
        return false;
      }
    }
    return true;
  };

  const bookMeetingSlot = (e) => {
    e.preventDefault();
    sessionStorage.setItem("selectedItem", JSON.stringify(selectedItem));
    sessionStorage.setItem("selectedSpase", JSON.stringify(item));
    sessionStorage.setItem("selectedDate", JSON.stringify(date));
    let selectedItems = [];
    selectedMeetingSlots?.map((slot) => {
      if (slot?.isSelected) {
        selectedItems.push(slot);
      }
    });
    if (selectedItems.length > 0) {
      setIsSelected(true);
    }
    sessionStorage.setItem(
      "selectedAllSlot",
      JSON.stringify(selectedMeetingSlots)
    );
    if (selectedItems.length == 0) {
      let url;
      if (searchParamsVal !== undefined) {
        url = `/booking-detail/${accessKey}?${
          searchParamsVal && searchParamsVal
        }`;
      } else {
        url = `/booking-detail/${accessKey}`;
      }
      navigate(url, {
        state: {
          cityid,
          pickedDate,
          id: item.id,
          inventoryId,
          searchParamsVal,
        },
      });
    } else {
      sessionStorage.setItem(
        "retryData",
        JSON.stringify({ item, inventoryId, selectedItems, screen: "retry" })
      );
      let url;
      if (searchParamsVal !== undefined) {
        url = `/payment/${accessKey}?${searchParamsVal && searchParamsVal}`;
      } else {
        url = `/payment/${accessKey}`;
      }
      navigate(`/payment/${accessKey}?${searchParamsVal && searchParamsVal}`, {
        state: {
          item,
          inventoryId,
          selectedItems,
          screen: "direct",
          searchParamsVal,
        },
      });
    }
  };

//   useEffect(() => {
//     const handleScroll = (e) => {
//       let centerX = document.documentElement.clientWidth / 2;
// let centerY = document.documentElement.clientHeight / 2;

// let elem = document.elementFromPoint(centerX, centerY);
// // console.log(centerX,"====",centerY,"====",window.scrollY);
// console.log(centerX,"====",centerY,"====",window.scrollY);
//       // const element = document.getElementById(index);
//       // console.log(document.scrollTop);
//       // if (element) {
//       //   // 👇 Will scroll smoothly to the top of the next section
//       //   if(element.id == index && window.scrollY > 0){
//       //     console.log(element.id,"===",refs.current.id)
//       //     element.scrollIntoView({ behavior: 'smooth' }); 
//       //   }
//       // }
//       // console.log(window.innerWidth / 2,"====",window.innerHeight / 2)
//       // const x = refs.current.offsetLeft;

//       // // Y
//       // const y = refs.current.offsetTop;
//       // console.log(x, "<====>", y);
//           //   const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;

//       // e.preventDefault();
//       // const isItemInView = centerLists.some(vi => vi.id == item.id);
//       // console.log(isItemInView,"item")
//       // if(window.scrollY > 340)
//       // {
//       // getMeetingSlot(item?.inventories[0]?.id)
//       // }
//       // Do something here ...
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => {
//       // This cleans up the event handler when the component unmounts.
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);

  const onCardChange = (isVisible) => {    
    if(isVisible) {
      if(selectedMeetingSlots === ""){
        getMeetingSlot(item?.inventories[0]?.id);
      }

      setCardVisible(true);
    }else{
      setCardVisible(false);
    }
    // console.log('Element is now %s', isVisible ? 'visible' : 'hidden');
  }
   
  return (
    <>
      <div
        className="row listing-row"
        ref={refs}
        index={index}
        // onScroll={Onscroll}
        id={index}
      >
        <div className="col-md-6">
          <div>
            {selectedInventoryImage === "" ? (
              <img
                src={
                  item?.inventories[0]?.images !== undefined &&
                  JSON.parse(item?.inventories[0]?.images).length > 0
                    ? JSON.parse(item?.inventories[0]?.images)[0]
                    : NoImage
                }
                alt="Premium Coworking"
                className="listing-image"
                onClick={(e) => {
                  bookMeetingSlot(e);
                }}
              />
            ) : (
              <img
                src={
                  selectedInventoryImage !== "" &&
                  JSON.parse(selectedInventoryImage).length > 0
                    ? JSON.parse(selectedInventoryImage)[0]
                    : NoImage
                }
                alt="Premium Coworking"
                className="listing-image"
                onClick={(e) => {
                  bookMeetingSlot(e);
                }}
              />
            )}

            <div className="mobileview-dnone">
              <p className="listing-text">Available Time Slot</p>
              <div className="slot-container-home">
                {selectedMeetingSlots.length > 0 ? (
                  <OwlCarousel
                    className="owl-theme"
                    items={11}
                    nav={true}
                    margin={0}
                    navText={[
                      `<img src=${leftarrow} class="like-nav-left">`,
                      `<img src=${rightarrow} class="like-nav-left">`,
                    ]}
                    key={Math.random()}
                    // slideBy={carouselIndex}
                    startPosition={changeDate ? 0 : carouselIndex}
                  >
                    {selectedMeetingSlots?.map((slot, index) => {
                      return (
                        <div className="item">
                          {slot?.booking_status == 0 ||
                          slot?.booking_status == "NA" ? (
                            <>
                              {/* {slot?.start?.split(":")[0] >
                            new Date().getHours() ? ( */}
                              <a
                                className={
                                  slot.isSelected
                                    ? "slot-box-text  disable-slot"
                                    : changeDate
                                    ? "slot-box-text"
                                    : slot?.start?.split(":")[0] >
                                      new Date().getHours()
                                    ? "slot-box-text"
                                    : "slot-box-text  disable-slot"
                                }
                                onClick={() => {
                                  let temp = new Date().getHours();
                                  if (
                                    slot?.start?.split(":")[0] > temp &&
                                    !changeDate
                                  ) {
                                    setCarouselIndex(index);
                                    setTimeSlotActive(true);
                                    getSelectedMeetingSlots(slot, index);
                                  } else if (changeDate) {
                                    getSelectedMeetingSlots(slot, index);
                                  } else {
                                    notify(
                                      "This slot is not available",
                                      "danger"
                                    );
                                  }
                                }}
                              >
                                {/* ✓ */}{" "}
                                {slot.isSelected
                                  ? "x"
                                  : changeDate
                                  ? "|"
                                  : slot?.start?.split(":")[0] >
                                    new Date().getHours()
                                  ? "|"
                                  : "x"}
                              </a>
                              {/* ) : (
                              <a className="slot-box-text disable-slot">x</a>
                            )} */}
                            </>
                          ) : (
                            <a className="slot-box-text disable-slot">x</a>
                          )}
                          <p className="slot-time-text">{slot?.start}</p>
                        </div>
                      );
                    })}
                  </OwlCarousel>
                ) : (
                  <div style={{ height: 20 }}>
                    <div className="dots-7"></div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 pt-sm-20">
          <div className="listing-detail listing-detail-view">
          <VisibilitySensor onChange={onCardChange}>
            <div>
              <h3
                className="listing-heading"
                onClick={(e) => {
                  bookMeetingSlot(e);
                }}
              >
                {item?.name}
              </h3>
              <p className="listing-sub-heading">{item?.address}</p>
              
              <div className={"select-seat-box"}>
                <>
                  {item?.inventories?.map((inverntory, index) => {
                    return (
                      <>
                        {inverntory?.id !== inventoryId ? (
                          <a
                            className={
                              centerId == item.id
                                ? "seat-box-text"
                                : "seat-box-text factive"
                            }
                            onClick={() => {
                              getMeetingSlot(inverntory?.id);
                              setInventoryId(inverntory?.id);
                              setCenterId(item?.id);
                              const updatedSlotState = selectedSlotArr.map(
                                (item, index) => false
                              );
                            }}
                          >
                            {inverntory.capacity} seater {inverntory.name}
                          </a>
                        ) : (
                          <>
                            <a className={"seat-box-text active"}>
                              {inverntory?.capacity} seater {inverntory?.name}
                            </a>
                          </>
                        )}
                      </>
                    );
                  })}
                </>
              </div>
              
            </div>
            </VisibilitySensor>
            <div className=" mobileview-dblock">
              <div className="facility-box mt-0 border-none px-0">
                {/* <p className="facility-box-item">{selectedItem?.amenities}</p> */}
                <p className="amenities-text">Amenities</p>
                {/* {selectedItem?.amenities.length > 3 && */}
                {Object.entries(selectedItem?.amenities).map((value) => {
                  if (value[1] !== "") {
                    return (
                      <div className="amenities-view">
                        <img
                          src={value[1]}
                          className="amenities-image"
                          data-tooltip-id="my-tooltip"
                          data-tooltip-content={value[0]}
                        />
                        {value[0] == "Vc" && (
                          <p className="amenities-content">
                            {" "}
                            *Additional INR 1500/hour for VC
                          </p>
                        )}
                      </div>
                    );
                  }
                })}
                {/* // } */}
              </div>
              <p className="listing-text">Available Time Slot</p>
              {selectedMeetingSlots.length > 0 ? (
                <div className="slot-container-home">
                  <OwlCarousel
                    className="owl-theme"
                    items={11}
                    nav={true}
                    margin={0}
                    navText={[
                      `<img src=${leftarrow} class="like-nav-left">`,
                      `<img src=${rightarrow} class="like-nav-left">`,
                    ]}
                    key={Math.random()}
                    // slideBy={carouselIndex}
                    startPosition={changeDate ? 0 : carouselIndex}
                  >
                    {selectedMeetingSlots?.map((slot, index) => {
                      return (
                        <div className="item">
                          {slot?.booking_status == 0 ||
                          slot?.booking_status == "NA" ? (
                            <>
                              {/* {slot?.start?.split(":")[0] >
                            new Date().getHours() ? ( */}
                              <a
                                className={
                                  slot.isSelected
                                    ? "slot-box-text disable-slot"
                                    : changeDate
                                    ? "slot-box-text"
                                    : slot?.start?.split(":")[0] >
                                      new Date().getHours()
                                    ? "slot-box-text"
                                    : "slot-box-text disable-slot"
                                }
                                onClick={() => {
                                  let temp = new Date().getHours();
                                  if (
                                    slot?.start?.split(":")[0] > temp &&
                                    !changeDate
                                  ) {
                                    setCarouselIndex(index);
                                    setTimeSlotActive(true);
                                    getSelectedMeetingSlots(slot, index);
                                  } else if (changeDate) {
                                    getSelectedMeetingSlots(slot, index);
                                  } else {
                                    notify(
                                      "This slot is not available",
                                      "danger"
                                    );
                                  }
                                }}
                              >
                                <>
                                  {slot.isSelected
                                    ? "x"
                                    : changeDate
                                    ? "|"
                                    : slot?.start?.split(":")[0] >
                                      new Date().getHours()
                                    ? "|"
                                    : "x"}
                                </>
                              </a>
                              {/* ) : (
                              <a className="slot-box-text disable-slot">x</a>
                            )} */}
                            </>
                          ) : (
                            <a className="slot-box-text disable-slot">x</a>
                          )}
                          <p className="slot-time-text">{slot?.start}</p>
                        </div>
                      );
                    })}
                  </OwlCarousel>
                </div>
              ) : (
                <div style={{ height: 20 }}>
                  <div className="dots-7"></div>
                </div>
              )}
            </div>
            <div className="mb-3 mb-mobile-3">
              <div className="book-slot-box pb-4">
                <div className="price-box">
                  <p className="price">
                    <span className="rupee-text">₹</span>
                    <span>{parseInt(selectedItem?.price)}/-</span>
                  </p>
                  <p className="price-sub-text">
                    Base Rate: Rs. {parseInt(selectedItem?.price)}/hour
                  </p>
                </div>
                <div className="book-btn-box">
                  <a
                    href=""
                    className="book-slot-btn"
                    onClick={(e) => {
                      bookMeetingSlot(e);
                    }}
                  >
                    BOOK A SLOT
                  </a>
                </div>
              </div>
              <Tooltip id="my-tooltip" className="ametooltip" />
              <hr className="mobileview-dblock mb-0"></hr>
              <div className="facility-box mt-0 mobileview-dnone">
                {/* <p className="facility-box-item">{selectedItem?.amenities}</p> */}
                <p className="amenities-text">Amenities</p>
                {/* {selectedItem?.amenities.length > 3 && */}
                {Object.entries(selectedItem?.amenities).map((value) => {
                  if (value[1] !== "") {
                    return (
                      <div className="amenities-view">
                        <img
                          src={value[1]}
                          className="amenities-image"
                          data-tooltip-id="my-tooltip"
                          data-tooltip-content={value[0]}
                        />
                        {value[0] == "Vc" && (
                          <p className="amenities-content">
                            {" "}
                            *Additional INR 1500/hour for VC
                          </p>
                        )}
                      </div>
                    );
                  }
                })}
                {/* // } */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CentersListView;
